<template>
	<TheBox :title="item.title" :titleLevel="3" :insideTable="true">
		<template #boxheaderRight>
			<div class="has-status" :class="`has-status--${$getStateColor('case', item.state)}`">
				{{ $getStateFullLabel('case', item.state) }}
			</div>
		</template>

		<el-row class="flex flex--justifyspacebetween">
			<span>
				{{ $recursivelyFindCategoryName(item.category.number) }}
			</span>
			<span v-if="item.voteEndDate">
				{{ $formatDate(item.voteEndDate) }}
			</span>
		</el-row>

		<div class="button-panel">
			<TheButton type="default" @buttonclick="goToDetailPage(item)">Details zum Fall</TheButton>
		</div>
	</TheBox>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ComplaintResponse } from '../../types/types';
import TheBox from '../TheBox.vue';
import TheButton from '../TheButton.vue';

export default defineComponent({
	name: 'BoxCase',
	data() {
		return {};
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	components: {
		TheBox,
		TheButton,
	},
	methods: {
		goToDetailPage(row: ComplaintResponse) {
			this.$router.push({ name: 'FallDetail', params: { id: String(row.id) } });
		},
	},
});
</script>
